<template>
  <div>
    <div class="my-16">
      <v-img src="it-logo.svg" contain height="150"></v-img>
    </div>
    <div>
      <v-text-field color="var(--color-it-blue)" v-model="lk_login" label="Логин" required outlined @keyup.enter="doLogin"></v-text-field>
      <v-text-field color="var(--color-it-blue)" type="password" v-model="lk_passwd" label="Пароль" required outlined @keyup.enter="doLogin"></v-text-field>
      <v-btn color="var(--color-it-blue)" block dark x-large @click="doLogin">Вход</v-btn>
      <div class="my-6">
        <p>Copyright 2023</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'IVLKLogin',

  data: () => ({
    lk_login: "",
    lk_passwd: "",
  }),
  methods: {
    async doLogin() {
      if ((this.lk_login != "")&&(this.lk_passwd != "")) {
        this.lk_login = this.lk_login.trim().toLowerCase()
        this.lk_passwd = this.lk_passwd.trim()
        try {
          const response = await this.req.post('auth', {
            login: this.lk_login,
            passwd: this.lk_passwd,
          })
          //console.log(response)
          this.$store.commit("loggedIn", {
            login: this.lk_login,
            token: response.data.token,
          })
          this.loginError = ""
          if (response.data.route == "main") {
            this.$router.push({ name: "Main" })
          }
        } catch (error) {
          //console.log(error)
          this.loginError = "Ошибка входа, проверьте имя пользователя"
          this.passwordError = "Ошибка входа, проверьте пароль"
        }
      } else {
        alert('Введите логин и пароль')
      }
    },
  },
}
</script>
